import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import s1 from '../assets/med/s1.jpg';
import s2 from '../assets/med/s2.jpg';
import s3 from '../assets/med/s3.jpg';
import s4 from '../assets/med/s4.jpg';
import s5 from '../assets/med/s5.jpg';
import s6 from '../assets/med/s6.jpg';
import s7 from '../assets/med/s7.jpg';
import s8 from '../assets/med/s8.jpg';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				

					

					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Strategic Focus Areas
                <br/>
                <span className="text-muted font-bold" style={{ fontSize: "20px" }}>Our Services</span>
								<span
									style={{
										display: "block",
										borderBottom: "3px solid var(--secondaryColor)",
										width: "50px",
										marginTop: "10px"
									}}
								>

								</span>
							</h6>
						</div>

						<div 
							className="col-md-12 d-none"
							style={{
								marginTop: "30px",
								marginBottom: "30px"
							}}
						>
							<HorizontalImageStrip
								images={[banner2, banner4, banner5, banner6, banner7]}
							/>

						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Youth Empowerment and Livelihoods"
                description="Supporting youth-led entrepreneurship and agribusiness initiatives- Skills training and financial literacy programsMarket linkages and business incubation"
								image={s1}
								navToLink={{
									item: 'services',
									subItem: 'road_construction'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Sustainable Agriculture and Food Security"
                description="Promotion of innovative and climate-smart agricultural practices- Establishment of farmer innovation hubs, field schools, nurseries, and crop museums"
								image={s2}
								navToLink={{
									item: 'services',
									subItem: 'building_works'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Renewable Energy and Environmental Sustainability"
                description="Awareness and adoption of renewable energy technologies (solar, biogas, biomass)- Environmental conservation, reforestation, and climate resilience initiatives"
								image={s3}
								navToLink={{
									item: 'services',
									subItem: 'bridge_construction'
								}}
							/>
						</div>

						
						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Health and Wellbeing"
                description="Youth health education, including Outbreak diseases reproductive health and HIV/AIDS awareness- Nutritionsensitive agriculture and WASH interventions"
								image={s4}
								navToLink={{
									item: 'services',
									subItem: 'materials_supply'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Education and Skills Development"
                description="Supporting quality education access- Establishment of training hubs and youth learning centres"
								image={s5}
								navToLink={{
									item: 'services',
									subItem: 'materials_supply'
								}}
							/>
						</div>

            <div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Research, Policy, and Advocacy"
                description="Participatory research on youth challenges and solutionsAdvocacy for inclusive, youth-responsive policies and programs"
								image={s6}
								navToLink={{
									item: 'services',
									subItem: 'materials_supply'
								}}
							/>
						</div>
						
						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
